export const editInsurancePageTranslations = {
  en: {
    editInsurancePage: {
      continue: 'Continue',
      fillOutNow: 'Fill this out now to save time at your next appointment',
      insuranceProvider: 'Insurance provider',
      memberIdCharacterMinimum: 'Member ID must be at least 1 character',
      memberIdInvalidCharacter: 'Please enter only letters and numbers',
      memberIdInvalidFormat: 'Invalid format, please re-enter',
      ocrIssueTitle:
        'Unable to read your card information. Add the missing information below to continue adding insurance coverage.',
      otherPredictedTitle:
        'Edit the insurance provider so that we can submit your insurance eligibility.',
      phoneInvalid: 'Please enter a valid phone number',
      requiredField: 'This field is required',
      unableToRead: 'Unable to read, please add manually',
    },
  },
  es: {
    editInsurancePage: {
      continue: 'Continuar',
      fillOutNow: 'Complete esto ahora para ahorrar tiempo en su próxima cita',
      insuranceProvider: 'Proveedor de seguros',
      memberIdCharacterMinimum:
        'El ID de Miembro debe tener al menos 1 carácter',
      memberIdInvalidCharacter: 'Por favor ingrese solo letras y números',
      memberIdInvalidFormat: 'Formato no válido, por favor vuelva a ingresar',
      ocrIssueTitle:
        'No se puede leer la información de su tarjeta. Agregue la información que falta para continuar agregando cobertura de seguro.',
      otherPredictedTitle:
        'Edite el proveedor de seguros para que podamos enviar su elegibilidad de seguro.',
      phoneInvalid: 'Por favor ingrese un número de teléfono válido',
      requiredField: 'Este campo es obligatorio',
      unableToRead: 'No se puede leer, agregue manualmente',
    },
  },
  ru: {
    editInsurancePage: {
      continue: 'Продолжить',
    },
  },
  ht: {
    editInsurancePage: {
      continue: 'Kontinye',
    },
  },
  km: {
    editInsurancePage: {
      continue: 'បន្ត',
    },
  },
  pt: {
    editInsurancePage: {
      continue: 'Continuar',
      fillOutNow:
        'Preencha isto agora para economizar tempo em sua próxima consulta',
      insuranceProvider: 'Provedor de seguro',
      ocrIssueTitle:
        'Não é possível ler as informações do seu cartão. Adicionar as informações que faltam abaixo para continuar adicionando a cobertura de seguro.',
    },
  },
  bn: {
    editInsurancePage: {
      continue: 'চালিয়ে যান',
      fillOutNow:
        'পরবর্তী অ্যাপয়েন্টমেন্টে, সময় বাঁচানোর জন্য, এটা এখনই পূরণ করুন',
      insuranceProvider: 'বীমা প্রদানকারী',
      ocrIssueTitle:
        'আপনার কার্ডের তথ্য পড়া যায়নি। বীমার কভারেজ যোগ করা চালিয়ে যেতে, নিচে অনুপস্থিত তথ্য যোগ করুন।',
    },
  },
  ja: {
    editInsurancePage: {
      continue: '続行',
      fillOutNow:
        '今この情報を入力いただくと、次回ご予約時の手間を省くことができます',
      insuranceProvider: '保険会社',
      ocrIssueTitle:
        '保険証の情報を読み込めませんでした。保険の追加を続行するには、以下に不足している情報を入力してください。',
    },
  },
  ko: {
    editInsurancePage: {
      continue: '계속',
      fillOutNow:
        '지금 작성을 완료하면 다음번 예약 시 시간을 절약할 수 있습니다',
      insuranceProvider: '보험 제공자',
      ocrIssueTitle:
        '카드 정보를 읽을 수 없습니다. 아래에 누락 정보를 추가한 후 계속해서 보험 보장을 추가하십시오.',
    },
  },
  ro: {
    editInsurancePage: {
      continue: 'Continuare',
      fillOutNow:
        'Completați acest lucru acum pentru a economisi timp la următoarea programare',
      insuranceProvider: 'Furnizor de asigurări',
      ocrIssueTitle:
        'Nu se pot citi informațiile cardului dvs. Adăugați informațiile care lipsesc mai jos pentru a continua să adăugați acoperire de asigurare.',
    },
  },
  zh: {
    editInsurancePage: {
      continue: '继续',
      fillOutNow: '现在填写此项以在下次预约时节省时间',
      insuranceProvider: '保险提供者',
      ocrIssueTitle:
        '无法读取您的保险卡的信息。添加以下缺失信息，以继续添加保险承保范围。',
    },
  },
};
